import sdl from '@jds/react-generated-sdl/JDSDatepickerMobileInternal';
import type { JDSDatepickerMobileInternalProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSDatepickerMobileInternalProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    state = 'default',
    open = false,
    previousButtonAriaLabel = 'Tap to Return',
    closeAriaLabel = 'Tap to Close',
    confirmAriaLabel = 'Tap to Confirm',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      state,
      open,
      previousButtonAriaLabel,
      closeAriaLabel,
      confirmAriaLabel,
      ...rest
    },
    'JDSDatepickerMobileInternal',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const DatepickerMobileInternal = withLogic(
  Component
) as React.FC<JDSDatepickerMobileInternalProps> & { slotName?: string };

DatepickerMobileInternal.displayName = 'DatepickerMobileInternal';
DatepickerMobileInternal.slotName = 'jds_datepicker_mobile_internal';

export { DatepickerMobileInternal, type JDSDatepickerMobileInternalProps };
